<template>
  <div class="mb-2">
    <vue-tailwind-datepicker 
      v-model="dateValue" 
      :formatter="formatter" 
      placeholder="Select dates" 
      :day-class="getDayClass"
      :disabled="disabled"
    />
    <span v-if="numberOfDays" class="ml-2 text-sm text-gray-500">{{ numberOfDays }} day(s) selected</span>
  </div>
</template>

<script setup>
import { ref, watch, computed, defineEmits, defineProps } from 'vue';
import VueTailwindDatepicker from 'vue-tailwind-datepicker';

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:dateRange']);
const dateValue = ref("");
const formatter = { date: 'DD MMM YYYY', month: 'MMM' };

const splitDates = computed(() => {
  if (dateValue.value && dateValue.value.includes(' ~ ')) {
    const dates = dateValue.value.split(' ~ ');
    return { start: dates[0] || null, end: dates[1] || null };
  }
  return { start: null, end: null };
});

watch(splitDates, (newDates) => {
  emit('update:dateRange', newDates);
});

const getDayClass = (date) => {
  const day = date.getDay();
  return (day === 0 || day === 6) ? 'disabled-day' : ''; // Disable Saturday (6) and Sunday (0)
};

const numberOfDays = computed(() => {
  if (splitDates.value.start && splitDates.value.end) {
    const start = new Date(splitDates.value.start);
    const end = new Date(splitDates.value.end);
    let count = 0;
    while (start <= end) {
      const day = start.getDay();
      if (day !== 0 && day !== 6) { // Count only weekdays
        count++;
      }
      start.setDate(start.getDate() + 1);
    }
    return count;
  }
  return 0;
});
</script>

<style scoped>
/* Style to disable weekends */
.disabled-day {
  pointer-events: none;
  opacity: 0.5;
}
</style>
